import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_ERROR_NOTIFICATION } from '@core/error-handling/services/http-error-notification.interceptor';
import { environment } from '@environments/environment';
import { AcompanhamentoAnexo } from '../models/acompanhamento-pedagogico.types';

/**
 * Serviço responsável por operações de anexos vinculados a acompanhamentos pedagógicos.
 *
 * O endpoint de arquivos segue o gateway Zuul: /zuul/api/commons/arquivos
 * - Listagem:  GET  /zuul/api/commons/arquivos?entidade=ACOMPANHAMENTO_PEDAGOGICO&entidadeId={id}
 * - Upload:    POST /zuul/api/commons/arquivos — multipart/form-data com params acima
 * - Download:  GET  /zuul/api/commons/arquivos/{id}/download — autenticado via header
 *   Authorization/User-Access (injetados pelo AuthInterceptorService), sem token na URL.
 * - Exclusão:  DELETE /zuul/api/commons/arquivos/{id}
 */
@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoPedagogicoAnexoApiService {
  private readonly baseUrl = `${environment.apiUrlAnexos}/commons/arquivos`;
  private readonly quietContext = new HttpContext().set(SKIP_ERROR_NOTIFICATION, true);

  constructor(private http: HttpClient) {}

  uploadAnexo(file: File): Observable<AcompanhamentoAnexo> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<AcompanhamentoAnexo>(this.baseUrl, formData);
  }

  deleteAnexo(anexoId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${anexoId}`);
  }

  /** Baixa via blob (não por URL direta) para evitar expor o access_token no histórico/logs/Referer. */
  downloadAnexo(anexoId: number, nomeArquivo?: string): void {
    this.http.get(`${this.baseUrl}/${anexoId}/download`, {
      responseType: 'blob',
      context: this.quietContext
    }).subscribe((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = nomeArquivo || `anexo-${anexoId}`;
      link.click();
      window.URL.revokeObjectURL(blobUrl);
    });
  }
}
